/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FareBasisIndexValidationData,
    FareBasisIndexValidationDataFromJSON,
    FareBasisIndexValidationDataFromJSONTyped,
    FareBasisIndexValidationDataToJSON,
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface FareBasisValidationData
 */
export interface FareBasisValidationData {
    /**
     * 
     * @type {Array<ValidationMessage>}
     * @memberof FareBasisValidationData
     */
    fareBasesValidationMessages?: Array<ValidationMessage> | null;
    /**
     * 
     * @type {Array<FareBasisIndexValidationData>}
     * @memberof FareBasisValidationData
     */
    fareBasesBrokenIndexes?: Array<FareBasisIndexValidationData> | null;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof FareBasisValidationData
     */
    fareBasisMatch?: ValidationMessage;
}

export function FareBasisValidationDataFromJSON(json: any): FareBasisValidationData {
    return FareBasisValidationDataFromJSONTyped(json, false);
}

export function FareBasisValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FareBasisValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fareBasesValidationMessages': !exists(json, 'fareBasesValidationMessages') ? undefined : (json['fareBasesValidationMessages'] === null ? null : (json['fareBasesValidationMessages'] as Array<any>).map(ValidationMessageFromJSON)),
        'fareBasesBrokenIndexes': !exists(json, 'fareBasesBrokenIndexes') ? undefined : (json['fareBasesBrokenIndexes'] === null ? null : (json['fareBasesBrokenIndexes'] as Array<any>).map(FareBasisIndexValidationDataFromJSON)),
        'fareBasisMatch': !exists(json, 'fareBasisMatch') ? undefined : ValidationMessageFromJSON(json['fareBasisMatch']),
    };
}

export function FareBasisValidationDataToJSON(value?: FareBasisValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fareBasesValidationMessages': value.fareBasesValidationMessages === undefined ? undefined : (value.fareBasesValidationMessages === null ? null : (value.fareBasesValidationMessages as Array<any>).map(ValidationMessageToJSON)),
        'fareBasesBrokenIndexes': value.fareBasesBrokenIndexes === undefined ? undefined : (value.fareBasesBrokenIndexes === null ? null : (value.fareBasesBrokenIndexes as Array<any>).map(FareBasisIndexValidationDataToJSON)),
        'fareBasisMatch': ValidationMessageToJSON(value.fareBasisMatch),
    };
}


